import './videos.css'

const Video = ({data}) => {

      if(data.data) return 

      return (
            <div className="video_content">
                  <h2>{data[0].title}</h2>
                  <div className="video_box">
                  <iframe width="100%" height="100%" src={`https://www.youtube.com/embed/${data[0].id_video}`} title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" ></iframe>
                  </div>
            </div>
      )
}

export default Video
